import { Provider, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, NG_VALIDATORS, UntypedFormControl } from '@angular/forms';
import { ValidationResult } from '../validators/validation-result.model';

export abstract class ArrayStringValueAccessor implements ControlValueAccessor {
  _value: Array<string> = new Array<string>();

  public isValid = (): boolean => {
    //this function will get overriden in the inherited controls
    //to produce their own logic of valid or not
    return true;
  };
  public validationError: string = '';

  get value(): Array<string> {
    return this._value;
  }
  set value(v: Array<string>) {
    if (v != null && v != undefined) {
      if (v !== this._value) {
        this._value = v;
        this.onChange(v);
      }
    }
  }

  writeValue(value: Array<string>) {
    if (value != null && value != undefined) {
      this._value = value;
      this.onChange(value);
    }
  }

  onBlur() {
    this.onTouched();
  }

  validate = (c: UntypedFormControl): any => {
    if (this.isValid() == false) {
      //return any custom error object if not valid
      let validationResult: ValidationResult = new ValidationResult();
      validationResult.errors.push(this.validationError);
      return validationResult;
    } else {
      //return null if is valid
      return null;
    }
  };

  onChange = (_: any) => {};
  onTouched = () => {};
  registerOnChange(fn: (_: any) => void): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }
}

export function CreateArrayStringValueAccessorProvider(type: any): any {
  return {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => type),
    multi: true,
  };
}

export function CreateArrayStringValueValidationProvider(type: any): any {
  return {
    provide: NG_VALIDATORS,
    useExisting: forwardRef(() => type),
    multi: true,
  };
}
